<template>
  <div class="editFlexible">
    <button
      type="button"
      class="btn btnFull btnAddColumn"
      :class="{mt15: itemColumn.length, hasColumn: itemColumn.length}"
      @click="setColumn">
      {{locale.add_column}}
    </button>
    <div v-if="selectColumn" class="setColumn">
      <button
        v-for="column in columnType"
        :key="column"
        type="button"
        class="columnItem"
        :data-column="column"
        @click="addColumn(column)">
        {{columnName(column)}}
      </button>
    </div>
    <div v-if="widget" class="layer widgetLayer">
      <div class="inner">
        <button class="btnClose" @click="toggleWidget(false)"><span class="blind">close</span></button>
        <h2 class="layerTitle">{{locale.select_widget}}</h2>
        <div class="widgetList">
          <div
            v-for="widget in widgetList"
            :key="widget"
            :data-widget="widget"
            class="widgetItem">
            <button type="button"
              :data-widget="widget"
              @click="addColumn(widget)">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlexibleModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'itemColumn',
    'moduleIndex',
    'itemSetting'
  ],
  data () {
    return {
      selectColumn: false,
      columnType: [
        'text',
        'image',
        'qrcode',
        'smartvoice',
        'embed',
        'break',
        'widget'
      ],
      widget: false,
      widgetList: [
        'clock',
        // 'weather'
      ]
    }
  },
  methods: {
    setColumn () {
      this.selectColumn = !this.selectColumn
    },
    addColumn (columnName) {
      if (columnName === 'widget') {
        this.toggleWidget(true)
      } else {
        this.$emit('setColumn', columnName)
        this.widget = false
      }
    },
    columnName (columnName) {
      return this.locale[columnName]
    },
    toggleWidget (isOpen) {
      this.widget = isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.btnAddColumn {
  justify-content: center;
  color: $color-grey;
  border-color: $color-lgrey2;
  background-color: $bg-default;
}
.widgetLayer {
  .inner {
    align-items: flex-start !important;
    height: auto !important;
  }
}
.widgetList {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -8px;
  .widgetItem {
    flex: 1;
    max-width: 25%;
    margin-bottom: 15px;
    padding: 0 8px;
    button {
      position: relative;
      width: 100%;
      height: 82px;
      padding: 10px 0;
      border: 1px solid $color-lgrey2;
      background-color: $bg-default;
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        opacity: 0.5;
      }
      &:hover {
        border-color: $color-primary;
        background-color: $color-white;
        &:before {
          opacity: 0.8;
        }
      }
    }
    [data-widget="clock"]:before {
      background-image: url('~@/assets/img/modules/widget_clock.png');
    }
  }
}
</style>
